import { NO, UITextView } from "uicore-ts"
import { RHTextField } from "./RHTextField"
import { RHForms } from "./Utils_slop/RHDesignTokens"


export class RHTextArea extends RHTextField {
    
    
    constructor(elementID?: string, viewHTMLElement = null) {
        
        super(elementID, viewHTMLElement, UITextView.type.textArea)
        
        this.viewHTMLElement.removeAttribute("type");
        
        // Remove the centering flex layout and disable resize handles on the outer container.
        (this as RHTextArea).configureWithObject({
            style: {
                alignItems: "stretch",
                resize: "none",
                overflow: "hidden",
                padding: "0"
            }
        })
        
        // Make the actual <textarea> fill its parent with padding restored at this level.
        this.textElementView.configureWithObject({
            style: {
                resize: "none",
                overflow: "auto",
                // padding: "0.375rem 0.75rem",
                padding: RHForms.textFieldContentPadding,
                top: "0px",
                bottom: "0px",
                width: "100%",
                whiteSpace: "normal",
                boxSizing: "border-box",
                webkitUserSelect: "text"
            }
        })
        
        this.pausesPointerEvents = NO
        
    }
    
    
    override get viewHTMLElement(): HTMLTextAreaElement & HTMLInputElement {
        
        // @ts-ignore
        return super.viewHTMLElement
        
    }
    
    override intrinsicContentHeight(constrainingWidth: number = 0): number {
        return Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(this)))
            .intrinsicContentHeight
            .call(this, constrainingWidth)
    }
    
    
}
